export default __webpack_public_path__ + "static/pict2-c9dc89de9cfbfaf709ef7b4821cf9d40.png";